import { BattleResultType } from '../types/BattleState';
import { MonsterBattleState } from '../types/Monster';

export interface PartyMemberState {
  monsterId: string;
  isDefeated: boolean;
  /** null = 未戦闘（バトル開始時にモンスターの初期値を使用）、number = 前の対戦からの引き継ぎ値 */
  remainingSpecialCount: number | null;
  usedReflectCount: number;
  /** null = 未戦闘（バトル開始時にモンスターの初期値を使用）、number = 前の対戦からの残りHP */
  currentHp: number | null;
}

/**
 * 現在のインデックスより後で最初の生存メンバーのインデックスを返す。
 * 控えが全員倒れている場合は null を返す。
 */
export function getNextPartyIndex(
  party: PartyMemberState[],
  currentIndex: number
): number | null {
  for (let i = currentIndex + 1; i < party.length; i++) {
    if (!party[i].isDefeated) return i;
  }
  return null;
}

/**
 * バトル後のパーティ状態を更新する（immutable）。
 * 生存した場合は使用回数を引き継ぎ、敗北した場合は isDefeated=true にする。
 */
export function updatePartyAfterBattle(
  party: PartyMemberState[],
  index: number,
  monsterState: MonsterBattleState,
  isDefeated: boolean
): PartyMemberState[] {
  return party.map((member, i) => {
    if (i !== index) return member;
    return {
      ...member,
      isDefeated,
      remainingSpecialCount: monsterState.remainingSpecialCount,
      usedReflectCount: monsterState.usedReflectCount,
      currentHp: monsterState.currentHp,
    };
  });
}

/**
 * パーティが全滅しているか判定する。
 */
export function isPartyDefeated(party: PartyMemberState[]): boolean {
  return party.every((m) => m.isDefeated);
}

/**
 * バトル結果からプレイヤーと敵のどちらが敗北したかを返す。
 */
export function determine3v3BattleOutcome(resultType: BattleResultType): {
  playerDefeated: boolean;
  enemyDefeated: boolean;
} {
  return {
    playerDefeated:
      resultType === BattleResultType.PLAYER2_WIN ||
      resultType === BattleResultType.DRAW,
    enemyDefeated:
      resultType === BattleResultType.PLAYER1_WIN ||
      resultType === BattleResultType.DRAW,
  };
}
